Namespace 'Monitoring.Reports.Publications'
class Monitoring.Reports.Publications.TimeGranularity extends  Backbone.Model

  initialize: (dateFrom, dateTo, @listener) ->
    @dateFrom = dateFrom
    @dateTo = dateTo
    @minimumDate = dateFrom
    @maximumDate = dateTo
    @dimension = 'history'

  changeByDimension: (dimension) ->
    @dimension = dimension
    # if(dimension == "daily")
    #   @dateFrom = @getMaximumDate (@decrementDays(@dateTo, 1))

    # if(dimension == "weekly")
    #   @dateFrom = @getMaximumDate (@decrementDays(@dateTo, 6))
    
    # if(dimension == "monthly")
    #   @dateFrom = @getMaximumDate (@decrementDays(@dateTo, 27))
    # @listener.changeTimeInTemplate(@dateFrom, @dateTo)

  changeDates:(dateFrom, dateTo) ->
    @dateFrom = dateFrom
    @dateTo = dateTo
    @listener.changeTimeInTemplate(@dateFrom, @dateTo)

  decrementDays:(dateTo, days) ->
    dateToCopy = new Date(dateTo)
    newDay = dateToCopy.getDate() - days
    new Date(dateToCopy.setDate(newDay))

  decrementMonth: (dateTo, times) ->
    dateToCopy = new Date(dateTo)
    newMonth = dateToCopy.getMonth() - times
    new Date (dateToCopy.setMonth(newMonth))

  formatToString:(date) ->
    date.toLocaleDateString()

  getMaximumDate: (date) ->
    if (date < @minimumDate)
      @minimumDate
    else
      date

  dateWithTimezone: (date) =>
    Date.create "#{date} #{@timezone.getSelectedTimeZone()}"
